export default __webpack_public_path__ + "static/media/depositIconDark.fd022a44.svg";